module.exports = __webpack_public_path__ + "static/img/sharpoint1.5ee71b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sharpoint1.jpg
// module id = UtX7
// module chunks = 0